import { useEffect, useState } from "react";

import { previewHistory } from "../useLearning";

export const CONTRIBUTION_STATUS = Object.freeze({ NONE: "none", LOADING: "loading", READY: "ready", FAILED: "failed" });

const NONE = Object.freeze({ status: CONTRIBUTION_STATUS.NONE, data: null });
const LOADING = Object.freeze({ status: CONTRIBUTION_STATUS.LOADING, data: null });
const FAILED = Object.freeze({ status: CONTRIBUTION_STATUS.FAILED, data: null });

/**
 * What one learned case adds to its cause's track record: the history preview (the same read-only figure the Undo confirm
 * shows), loaded when the popup opens for a case the server can undo or redo. {status, data, retry}; `data` is the preview
 * ({action, percent_now, percent_after, change_points, cases_now, cases_after}). A case that cannot be undone: NONE, no request.
 */
export default function useContribution(eid, enabled) {
  const [round, setRound] = useState(0);
  const [state, setState] = useState(() => (enabled && eid ? LOADING : NONE));

  useEffect(() => {
    if (!enabled || !eid) { setState(NONE); return undefined; }
    let live = true;
    setState(LOADING);
    previewHistory(eid)
      .then((preview) => { if (live) setState(preview ? { status: CONTRIBUTION_STATUS.READY, data: preview } : NONE); })
      .catch(() => { if (live) setState(FAILED); });
    return () => { live = false; };
  }, [eid, enabled, round]);

  return { ...state, retry: () => setRound((n) => n + 1) };
}
